import {useMemo} from "react";

import {getReservationNameError} from "../utils/get_reservation_name_error";
import {useRefState} from "./use_ref_state";

export interface IReservationNameFormState {
    isSaving: boolean;
    // why the last submit failed; null before the first submit
    errorMessage: string | null;
    // the name saved by the form - the profile query may still hold the previous one
    savedName: string | null;
}

export interface IReservationNameFormActions {
    // read when the form is submitted - one save at a time
    isSaving: () => boolean;
    // the trimmed name to save, or null when it is refused and the form shows why
    startSave: (name: string) => string | null;
    saveFailed: (errorMessage: string) => void;
    saved: (name: string) => void;
    // the API has rejected the profile name of a code request - only a rejection of a name the form has saved needs the API text, the step explains the first one
    rejected: (apiMessage: string) => void;
    reset: () => void;
}

const INITIAL_STATE: IReservationNameFormState = {isSaving: false, errorMessage: null, savedName: null};

// The name form that completes a profile the API has rejected for its name
export const useReservationNameForm = (): [IReservationNameFormState, IReservationNameFormActions] => {
    const [state, stateRef, setState] = useRefState(INITIAL_STATE);

    const actions = useMemo((): IReservationNameFormActions => {
        const update = (changes: Partial<IReservationNameFormState>) => setState({...stateRef.current, ...changes});

        return {
            isSaving: () => stateRef.current.isSaving,
            startSave: (name) => {
                const trimmedName = name.trim();
                const errorMessage = getReservationNameError(trimmedName);

                if (errorMessage !== null) {
                    update({errorMessage});
                    return null;
                }

                update({isSaving: true, errorMessage: null});
                return trimmedName;
            },
            saveFailed: (errorMessage) => update({isSaving: false, errorMessage}),
            saved: (name) => update({isSaving: false, errorMessage: null, savedName: name}),
            rejected: (apiMessage) => update({isSaving: false, errorMessage: stateRef.current.savedName === null ? null : apiMessage}),
            reset: () => setState(INITIAL_STATE)
        };
    }, [setState, stateRef]);

    return [state, actions];
};
import {useMemo} from "react";

import {getReservationNameError} from "../utils/get_reservation_name_error";
import {useRefState} from "./use_ref_state";

export interface IReservationNameFormState {
    isSaving: boolean;
    // why the last submit failed; null before the first submit
    errorMessage: string | null;
    // the name saved by the form - the profile query may still hold the previous one
    savedName: string | null;
}

export interface IReservationNameFormActions {
    // read when the form is submitted - one save at a time
    isSaving: () => boolean;
    // the trimmed name to save, or null when it is refused and the form shows why
    startSave: (name: string) => string | null;
    saveFailed: (errorMessage: string) => void;
    saved: (name: string) => void;
    // the API has rejected the profile name of a code request - only a rejection of a name the form has saved needs the API text, the step explains the first one
    rejected: (apiMessage: string) => void;
    reset: () => void;
}

const INITIAL_STATE: IReservationNameFormState = {isSaving: false, errorMessage: null, savedName: null};

// The name form that completes a profile the API has rejected for its name
export const useReservationNameForm = (): [IReservationNameFormState, IReservationNameFormActions] => {
    const [state, stateRef, setState] = useRefState(INITIAL_STATE);

    const actions = useMemo((): IReservationNameFormActions => {
        const update = (changes: Partial<IReservationNameFormState>) => setState({...stateRef.current, ...changes});

        return {
            isSaving: () => stateRef.current.isSaving,
            startSave: (name) => {
                const trimmedName = name.trim();
                const errorMessage = getReservationNameError(trimmedName);

                if (errorMessage !== null) {
                    update({errorMessage});
                    return null;
                }

                update({isSaving: true, errorMessage: null});
                return trimmedName;
            },
            saveFailed: (errorMessage) => update({isSaving: false, errorMessage}),
            saved: (name) => update({isSaving: false, errorMessage: null, savedName: name}),
            rejected: (apiMessage) => update({isSaving: false, errorMessage: stateRef.current.savedName === null ? null : apiMessage}),
            reset: () => setState(INITIAL_STATE)
        };
    }, [setState, stateRef]);

    return [state, actions];
};
